import React, { Component } from 'react';
import LoginPage from './components/loginPage/loginPage';
import './App.css';
import firebase from 'firebase';
import firebaseInit from './components/auth/firebaseInit';
import Dashboard from './components/dashboard/dashboard';
import ReactLoading from 'react-loading';
import UniqId from 'uniqid';

class App extends Component {
  state = {
    user: {},
    userId: '',
    isPageLoaded: false,
    renderedPage: 'loadingScreen',
    taskBoardToRender: '',
    allDashboards: [],
    newDataAvailableToWrite: false
  };
  uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.GithubAuthProvider.PROVIDER_ID
    ],
    callbacks: {
      signInSuccessWithAuthResult: () => false
    }
  };

  componentWillMount = () => {
    firebaseInit.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({
          user: !!user,
          isPageLoaded: true,
          userId: user.uid
        });
        this.getUserData(user.uid);
      } else {
        this.setState({
          user: !!user,
          isPageLoaded: true
        });
      }
    });
  };

  getUserData = userID => {
    let ref = firebaseInit.database().ref('/' + userID);
    ref.on('value', snapshot => {
      if (snapshot.val()) {
        var readItem = snapshot.val();
        readItem.allDashboards = readItem.allDashboards.map(element => {
          return {
            creationDate: element.creationDate,
            id: element.id,
            name: element.name,
            tags: element.tags,
            themeColor: element.themeColor,
            content: JSON.parse(element.content)
          };
        });
        readItem.newDataAvailableToWrite = false;
        this.setState(readItem);
      } else {
        this.setRenderedPage('dashboards');
      }
    });
    console.log('DATA RETRIEVED');
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState !== this.state &&
      !(this.state.allDashboards.length === 0) &&
      this.state.newDataAvailableToWrite
    ) {
      this.writeUserData();
    }
  }

  writeUserData = () => {
    var itemToWrite = this.state;
    itemToWrite.allDashboards = itemToWrite.allDashboards.map(element => {
      return {
        creationDate: element.creationDate,
        id: element.id,
        name: element.name,
        tags: element.tags,
        themeColor: element.themeColor,
        content: JSON.stringify(element.content)
      };
    });

    if (itemToWrite.renderedPage === 'loadingScreen') {
      itemToWrite.renderedPage = 'dashboards';
    }

    firebaseInit
      .database()
      .ref('/' + this.state.userId)
      .set(itemToWrite);
    console.log('DATA SAVED');
    this.setState({
      newDataAvailableToWrite: false
    });
  };

  setRenderedPage = pageToRender => {
    this.setState({
      renderedPage: pageToRender,
      newDataAvailableToWrite: true
    });
  };

  deleteExistingColumn = (taskBoardId, columnId) => {
    let newState = this.state;
    newState.allDashboards.forEach(item => {
      if (item.id === taskBoardId) {
        const tasksIdsOfColumn = item.content.columns[columnId].taskIds;
        tasksIdsOfColumn.forEach(taskID => {
          delete item.content.tasks[taskID];
        });
        delete item.content.columns[columnId];
        item.content.columnOrder.splice(
          item.content.columnOrder.indexOf(columnId),
          1
        );
        return;
      }
    });
    newState.newDataAvailableToWrite = true;
    this.setState(newState);
  };

  addNewColumn = (taskBoardId, colTitle) => {
    let newState = this.state;
    newState.allDashboards.forEach(item => {
      if (item.id === taskBoardId) {
        const newColId = String(UniqId());
        item.content.columns[newColId] = {
          id: newColId,
          title: colTitle,
          taskIds: []
        };
        item.content.columnOrder = [...item.content.columnOrder, newColId];
        return;
      }
    });

    newState.newDataAvailableToWrite = true;
    this.setState(newState);
  };

  addTaskToColumn = (taskBoardId, columnId, newTask) => {
    let newState = this.state;
    newState.allDashboards.forEach(item => {
      if (item.id === taskBoardId) {
        item.content.tasks[newTask.id] = newTask;
        item.content.columns[columnId].taskIds = [
          ...item.content.columns[columnId].taskIds,
          newTask.id
        ];
        return;
      }
    });

    newState.newDataAvailableToWrite = true;
    this.setState(newState);
  };

  getRenderedPage = () => {
    return this.state.renderedPage;
  };

  getAllDashboards = () => {
    return this.state.allDashboards;
  };

  setTaskBoardToRender = item => {
    this.setState({
      taskBoardToRender: item.id || ''
    });
  };

  getTaskBoardToRender = () => {
    let itemToRender = {};
    this.state.allDashboards.forEach(item => {
      if (item.id === this.state.taskBoardToRender) {
        itemToRender = item;
      }
    });
    return itemToRender;
  };

  addNewDashboard = newDashboardItem => {
    this.setState({
      allDashboards: this.state.allDashboards.concat(newDashboardItem),
      newDataAvailableToWrite: true
    });
    this.setRenderedPage('dashboards');
  };

  makeDashboardCopy = id => {
    let dashboardToCopy;
    this.state.allDashboards.forEach(item => {
      if (item.id === id) {
        dashboardToCopy = item;
      }
    });
    let newItem = {};
    newItem.name = dashboardToCopy.name;
    newItem.id = UniqId();
    newItem.creationDate = JSON.parse(JSON.stringify(new Date()));
    newItem.themeColor = dashboardToCopy.themeColor;
    newItem.tags = dashboardToCopy.tags;
    newItem.content = dashboardToCopy.content;
    this.addNewDashboard(newItem);
  };

  removeCurrentItem = dashboard => {
    this.setState({
      allDashboards: this.state.allDashboards.filter(function(item) {
        return item.id !== dashboard.id || item.name !== dashboard.name;
      }),
      newDataAvailableToWrite: true
    });
    this.setRenderedPage('dashboards');
  };

  renderTaskBoard = item => {
    this.setTaskBoardToRender(item);
    this.setRenderedPage('taskBoard');
  };

  modifyExistingTask = editedTask => {
    this.state.allDashboards.forEach(function(item) {
      if (item.id === editedTask.id) {
        item.name = editedTask.name;
        item.id = editedTask.id;
        item.themeColor = editedTask.themeColor;
        item.tags = editedTask.tags;
        item.creationDate = editedTask.creationDate;
        item.content = editedTask.content;
      }
    });
  };

  deleteExistingTask = (dasboardID, columnID, taskID) => {
    let newState = this.state;
    newState.allDashboards.forEach(item => {
      if (item.id === dasboardID) {
        delete item.content.tasks[taskID];
        item.content.columns[columnID].taskIds.splice(
          item.content.columns[columnID].taskIds.indexOf(taskID),
          1
        );
      }
    });

    newState.newDataAvailableToWrite = true;
    this.setState(newState);
  };

  validateUserAndServePage = () => {
    if (this.state.isPageLoaded) {
      return (
        <Dashboard
          getRenderedPage={this.getRenderedPage}
          setRenderedPage={this.setRenderedPage}
          getAllDashboards={this.getAllDashboards}
          addNewDashboard={this.addNewDashboard}
          makeDashboardCopy={this.makeDashboardCopy}
          removeCurrentItem={this.removeCurrentItem}
          renderTaskBoard={this.renderTaskBoard}
          taskBoardToRender={this.getTaskBoardToRender()}
          modifyExistingTask={this.modifyExistingTask}
          deleteExistingColumn={this.deleteExistingColumn}
          addTaskToColumn={this.addTaskToColumn}
          addNewColumn={this.addNewColumn}
          deleteExistingTask={this.deleteExistingTask}
        />
      );
    } else {
      return (
        <div className="page-loading-indicator">
          <ReactLoading
            type={'spin'}
            color={'#3498db'}
            height={'50%'}
            width={'50%'}
          />
        </div>
      );
    }
  };

  render() {
    return (
      <div className="App">
        {this.state.user ? (
          this.validateUserAndServePage()
        ) : (
          <LoginPage uiConfig={this.uiConfig} />
        )}
      </div>
    );
  }
}

export default App;
